import React, { useState, ReactNode, ReactElement, createContext, useContext } from 'react';

export type DialogContextType = {
  legacy: boolean;
  disableLegacy: () => void;
};
export const DialogContext = createContext<DialogContextType | undefined>(undefined);

export const useDialogContext = () => {
  const ctx = useContext(DialogContext);
  if (!ctx) {
    throw new Error('Dialog Context should be used inside the DialogContextProvider');
  }
  return ctx;
};

type DialogContextProviderProps = { children: ReactNode };

export const DialogContextProvider = ({ children }: DialogContextProviderProps): ReactElement => {
  const [legacy, setLegacy] = useState(true);
  const value: DialogContextType = { legacy, disableLegacy: () => setLegacy(false) };

  return <DialogContext.Provider value={value}>{children}</DialogContext.Provider>;
};
